import SectionHead from "./SectionHead";
import { isOpenable } from "../actions";
import chevronIcon from "../../../Assets/icon/explore/chevron-right.svg";

/**
 * A plain list of UniversalDialogueCards: title, optional context line, chevron.
 *
 * Used for the sections the contract defines but Figma does not draw yet —
 * SUGGESTED_ACTIONS (platform actions, routed by `action`; placement is an
 * open product call, O5) and HBR_DIALOGUES (defined, no content yet). A card
 * that can reach nothing is dropped, and an empty list renders nothing.
 */
function CardListSection({ title, subtitle, section, onOpenDialogue }) {
  const items = (section?.items || []).filter(isOpenable);
  if (items.length === 0) return null;

  return (
    <section className="ex-section">
      <SectionHead title={title} subtitle={subtitle} />
      <div className="ex-plist">
        {items.map((card, i) => (
          <button
            key={card.dialogue_id || card.action || i}
            type="button"
            className="ex-plist__row"
            onClick={() => onOpenDialogue?.(card)}
          >
            <span className="ex-plist__text">
              <span className="ex-plist__title">{card.title}</span>
              {card.context_line && (
                <span className="ex-plist__sub">{card.context_line}</span>
              )}
            </span>
            <span className="ex-plist__chevron">
              <img src={chevronIcon} alt="" width="16" height="16" />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default CardListSection;
